import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Sheet } from '../sheet/sheet';
import { OtaUpdateService } from '../../../core/services/ota-update';

/**
 * Bottom-sheet invitant l'utilisateur à redémarrer une fois un bundle OTA vérifié
 * prêt. Entièrement piloté par OtaUpdateService.updateAvailable().
 * Monté une seule fois dans app.ts.
 */
@Component({
  selector: 'app-ota-update-sheet',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Sheet],
  templateUrl: './ota-update-sheet.html',
})
export class OtaUpdateSheet {
  readonly ota = inject(OtaUpdateService);
}
